/**
 * The rounded form below is what the tables print. The margin needs this one: rounding each leg to two
 * decimals shifts the sum of implied probabilities by more than the edge being measured.
 */
export const americanToDecimalExact = (american) => {
  if (american === null || american === undefined || american === 0) {
    return null
  }
  return american > 0 ? american / 100 + 1 : 1 - 100 / american
}

export const americanToDecimal = (american) => {
  const decimal = americanToDecimalExact(american)
  return decimal === null ? null : Math.round(decimal * 100) / 100
}

export const formatAmerican = (american) => {
  if (american === null || american === undefined || american === 0) {
    return '—'
  }
  return american > 0 ? `+${american}` : String(american)
}

/**
 * The comparison grid already carries decimal prices, unlike the market snapshot which is american.
 * Running one through the other's converter turns every price into 1.0x, so they need separate helpers.
 */
export const formatDecimalPrice = (decimal, usPrices) => {
  // anything at or below evens is 'no price' here; 1 exactly would divide by zero on the american side
  if (!(decimal > 1)) {
    return '—'
  }
  if (!usPrices) {
    // the table stores three decimals, the grid shows two, and seeing both at once reads as a discrepancy
    return Math.round(decimal * 100) / 100
  }
  if (decimal > 2) {
    return `+${Math.round((decimal - 1) * 100)}`
  }
  if (decimal < 2) {
    return String(Math.round(-100 / (decimal - 1)))
  }
  return '+100'
}

export const formatPrice = (american, usPrices) => {
  if (american === null || american === undefined || american === 0) {
    return '—'
  }
  return usPrices ? formatAmerican(american) : americanToDecimal(american)
}
